import React, { useEffect, useState } from 'react';
import { useNavigate  , Link , useParams} from 'react-router-dom';

//URL
import {URL} from '../../context/URL'

//sweetAlrt 
import {SweetAlrt} from '../../context/SweetAlrt'

//mui
import { Typography , styled  ,Alert , TextField} from '@mui/material';


export default function OTP({nextStap}) {
    const {email  , type} = useParams();
    const navigate = useNavigate();

    const [otp , setOtp] = useState({sendOtp : "" ,conformOtp : "" });
    const [otpCheck , setOTPCheck]  = useState(false);


    useEffect(()=>{
        getOTP();
    },[]);

    const getOTP = async() =>{
        let random_otp =  Math.floor(Math.random() * 9999) + 1000;

        setOtp({...otp , sendOtp : random_otp});
        

       try{
       let result = await fetch(`${URL}/user/${email}/post_OTP/${random_otp}`);
           SweetAlrt("OTP send " , "success");
           console.log('send otp');
       }catch(error){
        SweetAlrt("OTP send " , "error");
        console.log("get otp api error : " + error );
       }

    }

    const handle_confrom = async()=>{
        console.log(otp.sendOtp , otp.conformOtp)
        if(otp.sendOtp == otp.conformOtp){
            setOTPCheck(false);
            SweetAlrt('Email id verification' , "success")
            navigate(`/${type}/${email}`);
        }else{
            setOTPCheck(true);
        }
       
    }

  return (
    <>
        
    <div className="container" style={{background :'#f2f2f2'}}>
        <div className="wrapper" style={{margin:'0px' , background :  '#FFFF'}}>
        <div className="title"><span>OTP verification</span></div>

            <form>
           

            <div >
                {
                    otpCheck ?  <TextField
                    error
                    color='info'
                    style={{width : '100%'}}
                    id="outlined-error"
                    label="OTP"
                    onChange={(e)=>setOtp({...otp   , conformOtp : parseInt(e.target.value)})}
                    helperText="invaild OTP"
                    /> 
                    :
                    <TextField
                        // error
                        color='info'
                        style={{width : '100%'}}
                        id="outlined-error"
                        label="OTP"
                        onChange={(e)=>setOtp({...otp   , conformOtp : parseInt(e.target.value)})}
                    />
                }
             </div>

            <div style={{textAlign : 'right' , margin:'0.5rem 0rem  1rem 0rem'}}>
            <div onClick={getOTP}><Link to={''} className='resendOTP'>Resend OTP ?</Link></div>
           </div>
            
            <div className="row button"onClick={handle_confrom}>
                <input type="button"  value="Continue"  />
            </div>
            
            

            </form>
        </div>
        </div>
    </>
  )
}
